import React, { useEffect, useMemo, useState } from 'react';

import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { Checkbox, makeStyles } from '@material-ui/core';
import { Map } from '@material-ui/icons';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import { currency } from 'hooks/Pipe';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
});

const columnsRoutes = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Código', accessor: 'code' },
  { Header: 'Nombre ruta', accessor: 'description' },
  { Header: 'Vendedor', accessor: 'SlpName' },
  { Header: 'N° pedidos', accessor: 'orders' },
  { Header: 'N° Clientes', accessor: 'customers' },
  { Header: 'N° paquetes', accessor: 'total_packages' },
  { Header: 'Peso', accessor: 'weight' },
  { Header: 'Volumen', accessor: 'volume' },
  { Header: 'Soles', accessor: 'total_amount' },
  { Header: '', accessor: 'actions', excelEnabled: false },
];

export default WithApp(function Route(props) {
  const classes = useStyles();

  const { idZone, dataFilter, checkedRoutes, setCheckedRoutes, refreshRoutes } = props;
  const [routes, setRoutes] = useState([]);
  const [routeCheck, setRouteCheck] = useState(false);

  const [allRoutesChecked, routesIndeterminated] = useMemo(() => {
    let allRoutesChecked = false;
    let routesIndeterminated = false;
    if (checkedRoutes.length === routes.length) allRoutesChecked = true;
    if (allRoutesChecked === false && checkedRoutes.length > 0) routesIndeterminated = true;
    if(routes.length === 0) allRoutesChecked = false;
    return [allRoutesChecked, routesIndeterminated];
  }, [checkedRoutes, routes]);

  function toggleAllRouteCheck() {
    if (allRoutesChecked) {
      setCheckedRoutes([]);
      return;
    }
    if (routesIndeterminated) {
      setCheckedRoutes([]);
      return;
    }
    setCheckedRoutes(routes);
  }

  async function listRoutes(idZone) {
    delete dataFilter.logi_warehouse_id;
    let response = await wsFindBy('base/route/with-orders', {
      ...dataFilter,
      base_zone_id: idZone,
    });
    if (response.success) {
      setRoutes(response.data);
    }
  }

  function deleteRow(item) {
    checkedRoutes.splice(
      checkedRoutes.findIndex((x) => x.id == item.id && x.base_seller_id == item.base_seller_id),
      1,
    );
    setCheckedRoutes([...checkedRoutes]);
  }

  useEffect(() => {
    listRoutes(idZone, dataFilter);
  }, [idZone, dataFilter, refreshRoutes]);

  return (
    <Card>
      <CardHeader icon>
        <CardIcon color={props.themeContext.buttonColor}>
          <Map />
        </CardIcon>
        <Checkbox
          checked={allRoutesChecked}
          indeterminate={routesIndeterminated}
          onChange={toggleAllRouteCheck}
        />
        <b style={{ color: 'black' }}>Marcar todo</b>
        <Checkbox
          checked={routeCheck}
          onChange={(e) => setRouteCheck(e.target.checked)}
        />
        <b style={{ color: 'black' }}>Ver rutas seleccionadas</b>
        <h4 className={classes.cardIconTitle}>Listado de rutas</h4>
      </CardHeader>
      <CardBody>
        <ReactTable
          firstColumn="80"
          defaultWidth="1400"
          indexRow={[0, 1, 4, 5, 6, 7, 8, 9, 10]}
          widthRow={[80, 100, 110, 110, 120, 120, 120, 120, 10]}
          indexColumn={[4, 5, 6, 7, 8, 9]}
          alignColumn={['center', 'center', 'right', 'right', 'right', 'right']}
          columns={columnsRoutes}
          data={(routeCheck 
            ? routes.filter((route) => 
                checkedRoutes.some((checked) => checked.id === route.id && checked.base_seller_id === route.base_seller_id)
              )
            : routes
          ).map((item, i) => {
            return {
              num: (
                <Checkbox
                  edge="start"
                  disableRipple
                  checked={checkedRoutes.some(
                    (obj) => obj.id == item.id && obj.base_seller_id == item.base_seller_id,
                  )}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setCheckedRoutes([...checkedRoutes, item]);
                    } else {
                      deleteRow(item);
                    }
                  }}
                  tabIndex={-1}
                />
              ),
              code: item.code,
              description: item.description,
              SlpName: ` ${item.SlpCode} - ${item.SlpName}`,
              orders: item.orders || 0,
              customers: item.customers || 0,
              total_packages: parseInt(item.total_packages || 0),
              weight: item.weight || 0,
              volume: item.volume || 0,
              total_amount: currency(item.total_amount),
              actions: '',
            };
          })}
        />
      </CardBody>
    </Card>
  );
});
